import emailjs from '@emailjs/browser';

const EmailNotification = ({guestName, guestEmail, subjectLine, fromName, message}) => {
    //setting up for emailjs service
    const serviceID = 'service_e1wzscb'
    const templateId ='template_xl8hswx'
    const publicKey = 'njUnqN5sBkR7cMmkd'
        
    const templateParams ={
    to_name: guestName,
    to_email:guestEmail,
    subject_line: subjectLine,
    from_name: fromName,
    message: message
    }

    emailjs.send(serviceID, templateId, templateParams,publicKey)
    .then((response) => {
      console.log('Email sent successfully', response)
    }).catch((error)=>{
      console.log('Error sending email:', error)
    })
}

export default EmailNotification
